import React, {useEffect, useState} from 'react'
import { Card, CardBody, Col, Row } from "reactstrap";


// components
import WlCardHeader from "../components/WlCardHeader";
import WishlistButtons from "../tools/WishlistButtons";

// labels
import {LB_DATE, LB_SPECIALITY,} from "../../i18n/i18n";

// utils
import { getWishlistOption, wishlistTypes } from "../../../util/WishlistUtils";
import WlCardComment from "../components/WlCardComment";


const SpecialViewComponent = props => {
    const option = getWishlistOption( wishlistTypes?.special )

    const [keyComponent, setKeyComponent] = useState(0)
    const selectedComponent = props?.component?.specials[keyComponent]
/*
    useEffect(()=> {
        setSelectedComponent(keyComponent)
    },[keyComponent])*/

    const onKeyComponentChange = value => {
        const isInLastPosition = keyComponent == (props?.component?.specials.length - 1)
        const isInFirstPosition = keyComponent == 0

        if(value == 1 && isInLastPosition) {
            setKeyComponent(0)
            return
        }

        if(value == -1 && isInFirstPosition) {
            setKeyComponent(props?.component?.specials.length - 1)
            return
        }

        setKeyComponent( keyComponent + value )
    }

    return <Card className={'wl-card'}>
        <CardBody className={'wl-card-content'}>
            <WlCardHeader
                icon={ option?.icon }
                title={ option?.title }
                subTitle={props?.component?.title}
                pax={props?.component?.pax}
            />


            <div className={'wl-card-body ptb-1em mb-1em'}>
                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title'}>{LB_SPECIALITY}</label> &nbsp;
                            <label className={'wl-label-value'}> {selectedComponent?.special?.title}</label>
                        </div>
                    </Col>
                    {
                        selectedComponent?.date && <Col sm={5}>
                            <div>
                                <label className={'wl-label-title'}>{LB_DATE}</label> &nbsp;
                                <label className={'wl-label-value'}> {selectedComponent?.date}</label>
                            </div>
                        </Col>
                    }
                </Row>
            </div>

            <WlCardComment comment={selectedComponent?.comment}/>

            <WishlistButtons
                from={'wishlist'}
                wishlist={props.wishlist}
                component={selectedComponent}
            />

            <div className={'po-absolute-cl btn-carousel'}>
                <i className={'fa fa-chevron-circle-left'} aria-hidden='true' onClick={()=>onKeyComponentChange(-1)}/>
            </div>
            <div className={'po-absolute-cr btn-carousel'}>
                <i className={'fa fa-chevron-circle-right'} aria-hidden='true' onClick={()=>onKeyComponentChange(1)}/>
            </div>
        </CardBody>
    </Card>
}

export default SpecialViewComponent